"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.requestTypeMap = exports.relationshipMap = exports.initialValuesConfig = exports.escalateTimeoutInterval = exports.componentConfig = exports.challengeTimeoutInterval = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _dateFns = require("date-fns");
var _sub = _interopRequireDefault(require("date-fns/sub"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var initialValuesConfig = exports.initialValuesConfig = {
  firstName: '',
  lastName: '',
  dob: '',
  email: '',
  phoneNumber: '',
  residentialAddress: '',
  city: '',
  state: 'CA',
  zipCode: '',
  consumer: false,
  workforceMember: false,
  authorizedAgent: false,
  isAuthorizedAgent: [],
  requestToKnowCategories: false,
  requestToDelete: false,
  requestToKnowSpecificData: false,
  requestToCorrect: false,
  requestToLimit: false,
  relationshipToMM: [],
  requestCategory: [],
  requestToCorrectText: '',
  formTouched: false,
  addressFinalized: 0,
  finalSubmit: 0,
  kbaIndex: 0,
  kbaSubmit: 0,
  answers: {},
  timeout: 0,
  redirect: false
};
var validationConfig = exports.validationConfig = yup.object().shape({
  firstName: yup.string('').required('First name is required').min(2, 'First name is required'),
  lastName: yup.string('').required('Last name is required').min(2, 'Last name is required'),
  dob: yup.string().matches(/\d{2}\/\d{2}\/\d{4}/, 'Please provide a valid date').required('Date of birth is required').test((info, meta) => {
    // Check that string is valid date
    var newDate = parseDateString(null, info);
    if (newDate.toString() === 'Invalid Date') {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Please provide a valid date'
      });
    }
    // We know it's a date, see if it's in the past
    var now = new Date();
    var maxValidAge = (0, _sub.default)(new Date(), {
      years: 18
    });
    var minValidAge = (0, _sub.default)(new Date(), {
      years: 110
    });
    if (newDate > maxValidAge || newDate < minValidAge) {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Must be greater than 18 and less than 110 years of age'
      });
    }
    return true;
  }),
  email: yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Please enter a valid email (example@example.com)').required('Please enter a valid email (example@example.com)'),
  phoneNumber: yup.string().matches(/^[2-9]\d{2}-\d{3}-\d{4}$/, 'Please enter a valid phone number').required('Phone number is required '),
  residentialAddress: yup.string().required('Residential address is required').min(3, 'Residential address is required'),
  city: yup.string().required('City is required').min(3, 'City is required'),
  zipCode: yup.string().required('ZIP code is required').test((info, meta) => {
    if ((info === null || info === void 0 ? void 0 : info.length) === 5 || (info === null || info === void 0 ? void 0 : info.length) === 10) {
      return true;
    }
    return meta.createError({
      path: "".concat(meta.path),
      message: 'Please provide a valid 5-digit or 9-digit ZIP code'
    });
  }),
  requestCategory: yup.array().min(1, 'Type of request is required').required('Type of request is required'),
  relationshipToMM: yup.array().min(1, 'Relationship is required').required('Relationship is required'),
  requestToCorrectText: yup.string().when('requestCategory', {
    is: requestCategory => requestCategory.includes('requestToCorrect'),
    then: yup.string().min(2, 'Additional information is required').required('Additional information is required')
  })
});
var componentConfig = exports.componentConfig = {
  firstName: {
    name: 'firstName',
    labelText: 'First name*',
    required: true,
    className: 'col-lg-6 col-sm-12',
    inputMask: 'firstName',
    maxLength: 40
  },
  lastName: {
    name: 'lastName',
    labelText: 'Last name*',
    required: true,
    className: 'col-lg-6 col-sm-12',
    inputMask: 'lastName',
    maxLength: 80
  },
  dob: {
    name: 'dob',
    labelText: 'Date of Birth (MM/DD/YYYY) *',
    required: true,
    className: 'col-sm-12',
    inputMask: 'date',
    maxLength: 10
  },
  email: {
    name: 'email',
    labelText: 'Email*',
    required: true,
    className: 'col-sm-12',
    maxLength: 80
  },
  phoneNumber: {
    name: 'phoneNumber',
    labelText: 'Phone number*',
    required: true,
    className: 'col-sm-12',
    inputMask: 'phone',
    maxLength: 12,
    placeholderText: '(XXX)-XXX-XXXX'
  },
  residentialAddress: {
    name: 'residentialAddress',
    labelText: 'Residential address*',
    required: true,
    className: 'col-sm-12',
    inputMask: 'residentialAddress',
    maxLength: 255
  },
  city: {
    name: 'city',
    labelText: 'City*',
    required: true,
    className: 'col-lg-4 col-sm-12',
    inputMask: 'city',
    maxLength: 40
  },
  zipCode: {
    name: 'zipCode',
    labelText: 'Zip code*',
    required: true,
    className: 'col-lg-4 col-sm-12',
    inputMask: 'zip',
    maxLength: 10,
    placeholderText: 'XXXXX'
  },
  consumer: {
    name: 'consumer',
    labelText: "I'm a consumer",
    className: 'col-sm-12',
    validationBucketName: 'relationshipToMM'
  },
  workforceMember: {
    name: 'workforceMember',
    labelText: "I'm a workforce member",
    className: 'col-sm-12',
    helperText: 'Includes employees, contractors, agents, general agents, brokers and applicants.',
    validationBucketName: 'relationshipToMM'
  },
  authorizedAgent: {
    name: 'authorizedAgent',
    labelText: "I'm an authorized agent",
    className: 'col-sm-12',
    helperText: 'Authorized agents should enter their own information in the request form and check this box to initiate a CCPA request on behalf of a California resident. We will contact the agent at the telephone number provided in the form after the form passes identity verification. To contact us directly please call 1-877-777-9154 with any questions.',
    validationBucketName: 'isAuthorizedAgent'
  },
  requestToKnowCategories: {
    name: 'requestToKnowCategories',
    labelText: 'Request to know categories of data',
    className: 'col-sm-12',
    validationBucketName: 'requestCategory'
  },
  requestToDelete: {
    name: 'requestToDelete',
    labelText: 'Request to delete',
    className: 'col-sm-12',
    validationBucketName: 'requestCategory'
  },
  requestToKnowSpecificData: {
    name: 'requestToKnowSpecificData',
    labelText: 'Request to know specific data',
    className: 'col-sm-12',
    validationBucketName: 'requestCategory'
  },
  requestToCorrect: {
    name: 'requestToCorrect',
    labelText: 'Request to correct',
    className: 'col-sm-12',
    validationBucketName: 'requestCategory'
  },
  requestToLimit: {
    name: 'requestToLimit',
    labelText: 'Request to limit the use of sensitive data',
    className: 'col-sm-12',
    validationBucketName: 'requestCategory'
  },
  requestToCorrectText: {
    name: 'requestToCorrectText',
    placeholder: 'Description of what you want corrected...'
  }
};
var relationshipMap = exports.relationshipMap = {
  'consumer': 'Consumer',
  'workforceMember': 'Workforce'
};
var requestTypeMap = exports.requestTypeMap = {
  "requestToKnowCategories": "C",
  "requestToDelete": "D",
  "requestToKnowSpecificData": "S",
  "requestToCorrect": "Corr",
  "requestToLimit": "Limit"
};
var escalateTimeoutInterval = exports.escalateTimeoutInterval = 240000;
var challengeTimeoutInterval = exports.challengeTimeoutInterval = 60000;
function parseDateString(value, originalValue) {
  return (0, _dateFns.isDate)(originalValue) ? originalValue : (0, _dateFns.parse)(originalValue, 'MM/dd/yyyy', new Date());
  ;
}